import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BillingComponent } from './billing.component';
import { FormsModule } from '@angular/forms';
import { AlertModule } from 'ngx-bootstrap/alert';
import { FooterModule } from "../footer/footer.module";
import { HeaderModule } from "../header/header.module";
import { ButtonModule, CheckboxModule, DropdownModule, InputsModule, RadioModule, TagsModule } from "@xref/xref-lib";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { StripeService } from "../../services/stripe/stripe.service";
import { TrialExplainerModalModule } from "../trial-explainer/trial-explainer-modal.module";
import { ChangePlanModalModule } from "../change-plan/change-plan-modal.module";
import { TooltipModule } from "@xref/xref-lib";
import { LoaderModule } from "../loader/loader.module";



@NgModule({
  declarations: [BillingComponent],
  imports: [
    CommonModule,
    FormsModule,
    AlertModule,
    FooterModule,
    HeaderModule,
    ButtonModule,
    NgbModule,
    BsDropdownModule.forRoot(),
    RadioModule,
    CheckboxModule,
    TrialExplainerModalModule,
    ChangePlanModalModule,
    DropdownModule,
    InputsModule,
    ButtonModule,
    TagsModule,
    TooltipModule,
    LoaderModule
  ],
  providers: [StripeService]
})
export class BillingModule { }
